import React, { useState } from 'react';
import { LlmModelData } from '../../../api/endpoints/llm';
import { Icon } from '../../../concepts/resources/Icon';
import { Button, Menu } from '../../../ui';
import { Tip } from '../../../ui/Tip';
import { Popover } from '../../canvas/ui/Popover';

export type ModelSelectorProps = {
    models: LlmModelData[],
    selected: LlmModelData,
    onChange: (model: LlmModelData) => void,
};

const ModelMenu = ({ models, selected, onChange }: ModelSelectorProps) =>
    <Menu>
        {models.map(model => (
            <Menu.Item key={model.modelName} onClick={() => onChange(model)}>
                <Menu.ItemText>
                    {model.modelName}
                </Menu.ItemText>
                <Menu.Shortcut keys={model.provider.label} />
            </Menu.Item>
        ))}
    </Menu>;

export const ModelSelector = ({ models, selected, onChange }: ModelSelectorProps) => {

    const [open, setOpen] = useState(false);

    const callOnChangeAndClose = (model: LlmModelData) => {
        onChange(model);
        setOpen(false);
    };

    return <Popover
        open={open}
        onOpenChange={setOpen}
        placement="top"
        inner={{ direction: 'up', offset: '.5' }}
        content={<ModelMenu models={models} selected={selected} onChange={callOnChangeAndClose} />}
    >
        <Tip text={open ? null : 'Switch Model'} position="top">
            <Button variant="text" size="sm" onAction={() => setOpen(true)}>
                {selected?.modelName || 'Loading...'} <Icon size="1" src="deqo://icons/hero/chevron-up" />
            </Button>
        </Tip>
    </Popover>;
};
